"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.642 13.2a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5m0 2.5a.5.5 0 0 0-.5.5v1.25h-1.25a.5.5 0 0 0 0 1h1.25v1.25a.5.5 0 0 0 1 0v-1.25h1.25a.5.5 0 0 0 0-1h-1.25V16.2a.5.5 0 0 0-.5-.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 13c.736 0 1.398.092 1.99.253a5.94 5.94 0 0 0-2.299 4.697c0 .72.128 1.41.363 2.049L12 20c-2.4 0-6-.167-6-2.1S7.8 13 12 13m0-9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7"
  })]
}), 'RecruitFilled');
//# sourceMappingURL=index.js.map